import { Resources } from '@app/resources';
import { UniversalBillingComponent } from './universal-billing/universal-billing.component';
import { BuildingDashboardComponent } from './universal-billing/building-dashboard/building-dashboard.component';
import { InvoiceDetailsComponent } from './billing/invoice/invoice-details/invoice-details.component';
import { PaymentsComponent } from '@modules/universal-billing/accounting/payments/payments.component';
import { ReportsComponent } from '@modules/universal-billing/reports/reports.component';
import { referenceRoute } from '@common/references/reference-routing.data';
import { ReadingService } from '@modules/universal-billing/reading/reading.service';
import { ResidentProfileComponent } from './residents/resident-profile/resident-profile.component';
import { ProfileComponent } from '@modules/settings/users/profile/profile.component';
import { PropertiesComponent } from '@modules/universal-billing/properties/properties.component';
import { PropertyProfileComponent } from './properties/property-profile/property-profile.component';
import { ApartmentProfileComponent } from './apartments/apartment-profile/apartment-profile.component';

import { RentersComponent } from '@modules/universal-billing/renters/renters.component';
import { ContractsComponent } from '@modules/universal-billing/property-management/contracts/contracts.component';
import { ContractDetailsComponent } from './property-management/contracts/contract-details/contract-details.component';
import { SmartMeterComponent } from '@modules/universal-billing/smart-meter/smart-meter.component';
import {
  PropertyMaintenanceComponent
} from './properties/property-profile/tabs/property-maintenance/property-maintenance.component';
import { RentersDetailsComponent } from '@modules/universal-billing/renters/renters-details/renters-details.component';
import invoicesRouting from '@modules/universal-billing/invoices/invoices.routing';
import { BookingsComponent } from '@modules/universal-billing/accounting/bookings/bookings.component';

export default [
  {
    path: Resources.UniversalBilling,
    component: UniversalBillingComponent,
  },
  {
    path: Resources.BuildingDashboard,
    component: BuildingDashboardComponent,
  },
  ...invoicesRouting,
  {
    path: Resources.InvoiceDetails,
    component: InvoiceDetailsComponent,
  },
  {
    path: Resources.Payments,
    component: PaymentsComponent,
  },
  {
    path: Resources.Bookings,
    component: BookingsComponent,
  },
  {
    path: Resources.Reports,
    component: ReportsComponent,
  },
  {
    path: Resources.ResidentProfile,
    component: ResidentProfileComponent,
  },
  {
    path: Resources.Properties,
    component: PropertiesComponent,
  },
  {
    path: Resources.PropertyContracts,
    component: ContractsComponent,
  },
  {
    path: Resources.PropertyContractsDetails,
    component: ContractDetailsComponent,
  },
  {
    path: Resources.PropertiesProfile,
    component: PropertyProfileComponent,
  },
  {
    path: Resources.RentersDetails,
    component: RentersDetailsComponent,
  },
  {
    path: Resources.Renters,
    component: RentersComponent,
  },
  {
    path: Resources.Profile,
    component: ProfileComponent,
  },
  {
    path: Resources.SmartBilling,
    component: SmartMeterComponent,
  },
  {
    path: Resources.PropertyMaintenance,
    component: PropertyMaintenanceComponent,
  },
  referenceRoute(Resources.Readings, ReadingService),
  {
    path: Resources.Residents,
    loadComponent: () => import('./residents/residents.component').then(c => c.ResidentsComponent),
  },
  {
    path: Resources.UniversalBillingApartments,
    loadComponent: () => import('./apartments/apartments.component').then(c => c.ApartmentsComponent),
  },
  {
    path: Resources.UniversalBillingApartmentsProfile,
    component: ApartmentProfileComponent
  },
  {
    path: Resources.Contract,
    loadComponent: () => import('./contract/contract.component').then(c => c.ContractComponent),
  },
  {
    path: Resources.Documents,
    loadComponent: () => import('@modules/universal-billing/accounting/documents/documents.component').then(m => m.DocumentsComponent),
  }
]
